import {FC} from 'react'
import clsx from 'clsx'
import {Address} from '../../../../componentsv1/shared/customer'
import CustomButton from '../../../../componentsv1/edit/customer/CustomButton'

interface Props {
  title: string
  isEditMode: boolean
  address: any
  onOpenDialog: () => void
}

export const AddressAction: FC<Props> = ({title, isEditMode, address, onOpenDialog}) => {
  const handleOpenDialog = () => {
    onOpenDialog()
  }

  return (
    <div className='d-flex flex-column mb-3'>
      <div
        className={clsx(
          'd-flex align-items-center fs-5 fw-bolder justify-content-between',
          !isEditMode && 'mb-2 pt-2'
        )}
      >
        {title}
        {isEditMode && (
          <CustomButton onClick={handleOpenDialog}>
            {address && address.id ? 'Change' : 'Create'}
          </CustomButton>
        )}
      </div>
      <Address address={address} />
    </div>
  )
}

export default AddressAction
